import {Component} from '@angular/core';

@Component({
    selector: 'divider',
    templateUrl: './divider.component.html'
})
export class DividerComponent {
}
